<template>
   <div class="locale-changer column" v-bind:class="{'mobile': $isMobile}">
      <a v-if="$i18n.locale === 'tr'" :href="url">EN</a>
      <a v-else :href="url">TR</a>
  </div>
</template>
<script>
export default {
  name: 'ChangeLanguage',
  data () {
    return {
      url: '/'
    }
  },
  mounted () {
    this.updateLangUrl()
  },
  methods: {
    updateLangUrl: function () {
      var tagUrl = this.getCanonical((this.$i18n.locale === 'tr') ? 'en' : 'tr')
      if (tagUrl === '') {
        this.url = (this.$i18n.locale === 'tr') ? '/en' : '/'
      } else {
        this.url = tagUrl
      }
    },
    getCanonical: function (lang) {
      var links = document.getElementsByTagName('link')
      for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('hreflang') === lang && links[i].getAttribute('rel') === 'alternate') {
          return links[i].getAttribute('href')
        }
      }
      return ''
    }
  },
  watch: {
    '$route' (to, from) {
      this.updateLangUrl()
    }
  }
}
</script>
<style>
.locale-changer {
  margin: auto 15px auto auto;
}
.locale-changer.mobile {
  margin: -1px 0px auto auto;
}
.locale-changer a {
  color: var(--text-color4);
}
</style>



// WEBPACK FOOTER //
// src/shared/widget/header/language.vue